import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Users, Shield, Clock, Award, Heart, Star } from "lucide-react";
import "./WhoWeAre.css";
import whoWeAreImg from "../../assets/who-we-are.webp";

const WhoWeAre = () => {
  return (
    <section className="who-we-are" id="who-we-are">
      <div className="who-we-are-container">
        {/* Left Image */}
        <div className="who-we-are-image">
          <div className="who-we-are-image-wrapper">
            <img src={whoWeAreImg} alt="Who We Are - Bhole Cab Service" />
            
            {/* Floating Stats */}
            <div className="who-we-are-stats">
              <div className="stat-item">
                <span className="stat-number">50+</span>
                <span className="stat-label">Fleet Vehicles</span>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-item">
                <span className="stat-number">4.9★</span>
                <span className="stat-label">Customer Rating</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Content */}
        <div className="who-we-are-text">
          <div className="who-we-are-eyebrow">
            <span className="who-we-are-eyebrow-line"></span>
            Who We Are
          </div>
          
          <h2>
            Driving <span>Excellence</span> in Every Journey
          </h2>
          
          <p>
            We are a trusted cab service provider based in Vadodara, offering
            one-way, round trips, and customized travel solutions. Our team
            consists of professional drivers, support staff, and travel
            coordinators who work together to ensure your journey is
            stress-free.
          </p>
          
          <p>
            We focus on punctuality, safety, and customer-first service.
            Every ride is backed by our commitment to quality and 
            reliability.
          </p>

          {/* Core Values */}
          <div className="who-we-are-values">
            <div className="value-item">
              <div className="value-icon">
                <Shield size={18} />
              </div>
              <div>
                <h4>Safety First</h4>
                <p>Verified drivers & well-maintained vehicles</p>
              </div>
            </div>
            <div className="value-item">
              <div className="value-icon">
                <Clock size={18} />
              </div>
              <div>
                <h4>On-Time Service</h4>
                <p>Punctuality is our promise to you</p>
              </div>
            </div>
            <div className="value-item">
              <div className="value-icon">
                <Heart size={18} />
              </div>
              <div>
                <h4>Customer First</h4>
                <p>Your satisfaction is our priority</p>
              </div>
            </div>
            <div className="value-item">
              <div className="value-icon">
                <Award size={18} />
              </div>
              <div>
                <h4>Trusted Service</h4>
                <p>10+ years of reliable transportation</p>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <Link to="/about" className="who-we-are-cta">
            <span>Know More About Us</span>
            <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;